export default __webpack_public_path__ + "static/media/amazon_music.48908d27.png";